var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row my-4" }, [
    _c("div", { staticClass: "container my-auto" }, [
      _c("header", { staticClass: "my-4" }, [
        _c("img", {
          staticClass: "mx-auto d-block",
          attrs: { src: "bundle-vue2/" + _vm.logo, alt: "Logo" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card card-resetpassword mx-auto my-4" }, [
        !_vm.resetComplete
          ? _c("div", { staticClass: "card-body" }, [
              !_vm.isNewPersoneelslid
                ? _c("h5", { staticClass: "card-title text-center" }, [
                    _vm._v("\n          Wachtwoord opnieuw instellen\n        ")
                  ])
                : _c("h5", { staticClass: "card-title text-center" }, [
                    _vm._v("Wachtwoord instellen")
                  ]),
              _vm._v(" "),
              _c(
                "form",
                { staticClass: "form-signin", attrs: { method: "post" } },
                [
                  _c("div", { staticClass: "form-label-group" }, [
                    _c("label", { attrs: { for: "password" } }, [
                      _vm._v("Wachwoord")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      class: [
                        _vm.$v.$invalid ? "is-invalid" : "",
                        "form-control"
                      ],
                      attrs: {
                        disabled: _vm.loading,
                        type: "password",
                        id: "password",
                        name: "password",
                        placeholder: "Wachtwoord",
                        required: "",
                        autofocus: ""
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-label-group" }, [
                    _c("div", { staticClass: "form-label-group" }, [
                      _c("label", { attrs: { for: "confirmPassword" } }, [
                        _vm._v("Wachwoord bevestigen")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.confirmPassword,
                            expression: "confirmPassword"
                          }
                        ],
                        class: [
                          !_vm.passwordsMatch && !_vm.isEmptyConfirm
                            ? "is-invalid"
                            : "",
                          "form-control"
                        ],
                        attrs: {
                          disabled: _vm.loading,
                          type: "password",
                          id: "confirmPassword",
                          name: "confirmPassword",
                          placeholder: "Wachtwoord bevestigen",
                          required: "",
                          autofocus: ""
                        },
                        domProps: { value: _vm.confirmPassword },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.confirmPassword = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    !_vm.passwordsMatch && !_vm.isEmptyConfirm
                      ? _c("div", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n              Uw ingevoerde wachtwoorden komen niet overeen.\n            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$v.$invalid
                      ? _c("div", { staticClass: "text-danger mt-0" }, [
                          _vm._v(
                            "\n              Uw wachtwoord moet uit minstens 10 tekens bestaan.\n            "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  !_vm.isNewPersoneelslid
                    ? _c(
                        "ehr-button",
                        {
                          staticClass: "btn-block mt-4",
                          attrs: {
                            "button-type-class": "btn-primary",
                            loading: _vm.loading,
                            disabled: !_vm.passwordsMatch || _vm.isEmptyForm
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.doResetPassword($event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            Wachtwoord opnieuw instellen\n          "
                          )
                        ]
                      )
                    : _c(
                        "ehr-button",
                        {
                          staticClass: "btn-block mt-4",
                          attrs: {
                            "button-type-class": "btn-primary",
                            loading: _vm.loading,
                            disabled: !_vm.passwordsMatch || _vm.isEmptyForm
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.doResetPassword($event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            Wachtwoord instellen\n          "
                          )
                        ]
                      )
                ],
                1
              )
            ])
          : _c("div", { staticClass: "card-body" }, [
              !_vm.isNewPersoneelslid
                ? _c("h5", { staticClass: "card-title text-center" }, [
                    _vm._v("\n          Wachtwoord opnieuw instellen\n        ")
                  ])
                : _c("h5", { staticClass: "card-title text-center" }, [
                    _vm._v("Wachtwoord instellen")
                  ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-success text-center mt-2 mb-2" },
                [
                  _c("font-awesome-icon", {
                    attrs: { size: "4x", icon: ["fad", "check-circle"] }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isNewPersoneelslid
                ? _c("p", { staticClass: "text-muted text-center" }, [
                    _vm._v(
                      "\n          Uw wachtwoord werd aangepast. U kan nu\n          "
                    ),
                    _c("a", { attrs: { href: _vm.baseURL + "/login" } }, [
                      _vm._v("aanmelden")
                    ]),
                    _vm._v(".\n        ")
                  ])
                : _c("p", { staticClass: "text-muted text-center" }, [
                    _vm._v(
                      "\n          Uw wachtwoord werd ingesteld. U kan nu\n          "
                    ),
                    _c("a", { attrs: { href: _vm.baseURL + "/login" } }, [
                      _vm._v("aanmelden")
                    ]),
                    _vm._v(".\n        ")
                  ])
            ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }